export default __webpack_public_path__ + "static/media/Kontron S&T.8285ed63.png";